var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tiaozhuan"}},[_c('div',{staticClass:"center"},[_c('h3',[_vm._v("由于篇幅限制，未完待续！")]),_c('h4',[_vm._v("使用微信扫描下方二维码，回复书名 "),_c('span',[_vm._v("《"+_vm._s(_vm.bookInfo.title)+"》")])]),_c('h4',[_vm._v("马上阅读全文")]),_c('img',{attrs:{"src":_vm.getImg,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }